import { render, staticRenderFns } from "./station-details.vue?vue&type=template&id=48711481&"
import script from "./station-details.vue?vue&type=script&lang=js&"
export * from "./station-details.vue?vue&type=script&lang=js&"
import style0 from "./station-details.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports